module.exports = __webpack_public_path__ + "img/Consession.662ec2db.svg";